import template from './attendance_report_per_department_help.html'
import * as Utils from '../../../lib/savanna_utils.js'

class AttendanceDepartmentReportHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
}

class AttendanceDepartmentReportHelpPage
{
	constructor(bindings)
	{
		this.viewModel = new AttendanceDepartmentReportHelpViewModel(this);
		this.bindings = bindings;
	}

	async init()
	{
		Utils.refresh_data_visible_roles()
	}
}

// Register the dialog
export default {
	name: 'AttendanceDepartmentHelp',
	dialog_class: AttendanceDepartmentReportHelpPage,
	template: template,
	template_filename: 'translation/dialogs/attendance_report_per_department_help',
	provider: 'ps'
}
